import _ from "lodash";
import useThemeMediaQuery from "@fuse/hooks/useThemeMediaQuery";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import useFuseLayoutSettings from "@fuse/core/FuseLayout/useFuseLayoutSettings";
import useFuseSettings from "@fuse/core/FuseSettings/hooks/useFuseSettings";
import { useNavbarContext } from "./contexts/NavbarContext/useNavbarContext";
import { Tooltip } from "@mui/material";
import clsx from "clsx";

export type NavbarToggleButtonProps = IconButtonProps;

/**
 * The navbar toggle button.
 */
function NavbarToggleButton(props: NavbarToggleButtonProps) {
	const { toggleMobileNavbar, toggleNavbar, isOpen, mobileOpen } = useNavbarContext();
	const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down("lg"));
	const { config } = useFuseLayoutSettings();
	const { setSettings } = useFuseSettings();

	const isMenuOpen = isMobile ? mobileOpen : isOpen;

	const { className = "h-7 w-7 ml-2 hover:border hover:border-divider", children, ...rest } = props;

	// avoid unstable default prop by computing JSX inside render
	const resolvedChildren = children ?? (
		<Tooltip title={clsx(isMenuOpen ? "Fechar o menu de navegação" : "Abrir o menu de navegação")}>
			<FuseSvgIcon>lucide:panel-left</FuseSvgIcon>
		</Tooltip>
	);

	return (
		<IconButton
			size="small"
			onClick={() => {
				if (isMobile) toggleMobileNavbar();
				else if (config?.navbar?.style === "style-2")
					setSettings(_.set({}, "layout.config.navbar.folded", !config?.navbar?.folded));
				else toggleNavbar();
			}}
			{...rest}
			className={className}
		>
			{resolvedChildren}
		</IconButton>
	);
}

export default NavbarToggleButton;
